import Bowser from "bowser";
import Splide from "@splidejs/splide";
// import MicroModal from "micromodal";
import * as DOMPurify from "dompurify";
import Typewriter from "typewriter-effect/dist/core";

// MicroModal
// MicroModal.init({
//   onShow: function() {
//     document.querySelector("html").classList.add("locked");
//   },
//   onClose: function() {
//     document.querySelector("html").classList.remove("locked");
//   }
// });

jQuery(document).ready(function($) {
  // Inside of this function, $() will work as an alias for jQuery()
  // and other libraries also using $ will not be accessible under this shortcut
  // https://codex.wordpress.org/Function_Reference/wp_enqueue_script#jQuery_noConflict_Wrappers

  // Touch Device Detection
  var isTouchDevice = "ontouchstart" in document.documentElement;
  if (isTouchDevice) {
    $("body").removeClass("no-touch");
    $("body").addClass("touch");
  }

  // Browser detection via Bowser (https://github.com/lancedikson/bowser) - add detection as needed
  const userBrowser = Bowser.getParser(window.navigator.userAgent);
  const browser = userBrowser.getBrowser();

  if (browser.name === "Internet Explorer" && browser.version == "11.0") {
    $("body").addClass("ie-11");
  } else if (browser.name === "Safari") {
    $("body").addClass("safari");
  }

  // Site banner positioning
  function adjustBanner(banner, header) {
    let height = banner.css("height");

    header.css("marginTop", height);
  }
  
  // Adjust banner on page load
  if( $(".site-banner").length ) {
    adjustBanner($(".site-banner"), $(".site-header"));
  }

  // Adjust banner on window resize
  $(window).on("resize", function() {
    adjustBanner($(".site-banner"), $(".site-header"));
  });

  // Menu functions
  function toggleMenu(icon, menu) {
    $("html").toggleClass("locked");
    $("body").toggleClass("locked masked");
    $(".site-header").toggleClass("open-nav");

    icon.toggleClass("active");
    menu.slideToggle();
  }

  function closeMenu(icon, menu) {
    if( menu.css("display") == "block" ) {
      $("html").removeClass("locked");
      $("body").removeClass("locked masked");
      $(".site-header").removeClass("open-nav");
    }

    icon.removeClass("active");
    menu.slideUp();
  }

  // Main menu function
  $(".menu-icon").on("click", function() {
    toggleMenu($(this), $(".nav--mobile"));
  });

  // Close menu on desktop
  $(window).on("resize", function() {
    if( $(window).width() > 1024 ) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Close menu on outside click
  $(document).on("click", function(e) {
    if( !$(e.target).closest(".site-header").length ) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Close menu on ESC key 
  $(document).on("keyup", function(e) {
    if( e.which == 27) {
      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });

  // Mobile menu sub-menu toggle
  $(".nav--mobile .menu-item-has-children > a").on("click", function(e) {
    e.preventDefault();

    $(this).siblings(".sub-menu").slideToggle();
    $(this).toggleClass("active");
  });

  // Typewriter text 
  if( $(".typewriter").length ) {
    $(".typewriter").each(function() {
      let phrases = $(this).attr("data-phrases").split(", "),
        count = phrases.length,
        typewriter;
      
      // Only loop if more than 1 phrase
      if( count > 1 ) {

        typewriter = new Typewriter(this, {
          loop: true,
          delay: 50,
          autoStart: true,
          strings: phrases,
        });

        typewriter.start();

      } else {

        typewriter = new Typewriter(this, {
          delay: 50,
        }).typeString(phrases[0]).start();
      }

    });
  }

  // Form Label Animation
  $(".gform_wrapper form .animated").find("input, select, textarea").on("focusin", function() {
  	$(this).parents(".animated").children("label").addClass("active-position active-weight active-color");

  	// Off focus
  	$(".gform_wrapper form .animated").find("input, select, textarea").on("focusout", function() {
  		if( $(this).val() !== "" ) { // Remove active weight and keep raised position if input has content
  			$(this).parents(".animated").children("label").removeClass("active-weight");
  		} else { // Else remove both weight and raised position
  			$(this).parents(".animated").children("label").removeClass("active-position active-weight active-color");
  		}
  	});
  });

  // Dropdowns
  $(".dropdown__parent").on("click", function() {
    $(this).toggleClass("open");
    $(this).siblings(".dropdown__menu").slideToggle();
  });
  
  $(".dropdown__parent").on("keyup", function(e) {
    // Enter key
    if( e.which == 13) {
      $(this).toggleClass("open");
      $(this).siblings(".dropdown__menu").slideToggle();
    }
  
    // Esc key
    if( e.which == 27) {
      $(this).removeClass("open");
      $(this).siblings(".dropdown__menu").slideUp();
    }
  });
  
  // Close dropdown on selection
  $(".dropdown__menu a").on("click", function() {
    $(this).parents(".dropdown").find(".dropdown__parent").removeClass("open");
    $(this).parents(".dropdown__menu").slideUp();
  });
  
  // Close dropdowns on outside click
  $(document).on("click", function(e) {
    if(!$(e.target).closest(".dropdown").length) {
      if($(".dropdown__menu").css("display") === "block") {
        $(".dropdown__parent").removeClass("open");
        $(".dropdown__menu").slideUp();
      }
    }
  });

  // Logo slider section (SplideJS)
  if( $(".logo-slider-section__slider").length ) {
    $(".logo-slider-section__slider").each(function() {
      new Splide(this, {
        type: "loop",
        perPage: 8,
        perMove: 1,
        pagination: false,
        breakpoints: {
          1024: {
            perPage: 6
          },
          767: {
            perPage: 4
          },
          500: {
            perPage: 3
          }
        }
      }).mount();
    });
  }

  // Testimonial slider section (SplideJS)
  if( $(".testimonial-slider-section").length ) {
    $(".testimonial-slider-section").each(function() {
      let text = this.querySelector(".testimonial-slider-section__text-slider"),
        images = this.querySelector(".testimonial-slider-section__image-slider");

      let textSlider = new Splide(text, {
        type: "fade",
        perPage: 1,
        pagination: false,
        isNavigation: true,
        rewind: true, // allows infinite loop when fade true
      }).mount();

      let imageSlider = new Splide(images, {
        type: "fade",
        perPage: 1,
        pagination: false,
        arrows: false,
        rewind: true, // allows infinite loop when fade true
      }).mount();

      imageSlider.sync(textSlider);

    });
  }

  // Accordions section 
  $(".accordion__header").on("click", function() {
    // Close other accordions
    $(this).parents(".accordions-section").find(".accordion__header").not(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    $(this).parents(".accordions-section").find(".accordion__header").not(this).siblings(".accordion__content").slideUp();

    // Toggle this one
    if( $(this).find("i").hasClass("fa-plus") ) {
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
    } else {
      $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    }
    
    $(this).siblings(".accordion__content").slideToggle();
  });

  // Smooth anchor link scrolling 
  $("a[href*=\\#]").on("click", function (e) {
    let slug = this.href.split("#")[1].replace("#", "");

    // Only if no matching modal
    if( !$(".modal#modal-" + slug).length && !$(this).parents(".vendor-types") ) {
      e.preventDefault();
      if(this.pathname === window.location.pathname) {
        // Store hash
        let hash = this.hash;
  
        $("html, body").animate({
          scrollTop: $(hash).offset().top,
        }, 800, function(){
  
          window.location.hash = hash;
        });
      }
    }
  });

  // Trigger matching modal (if there) when hash 
  // if( window.location.hash) {
  //   let hash = window.location.hash.replace("#", "");

  //   if( $(".modal#modal-" + hash).length ) {
  //     MicroModal.show("modal-" + hash);
  //   }
  // }

  // Custom add to cart form with quantity param 
  // Pass variable to query string
  $("form.custom-add-to-cart").on("submit", function(e) {
    e.preventDefault();

    let data = $(this).find(":input"),
      qty = DOMPurify.sanitize(data[0].value),
      product = DOMPurify.sanitize(data[1].value),
      cart = DOMPurify.sanitize(data[2].value);

    let newUrl = `${cart}?add-to-cart=${product}&quantity=${qty}`;

    window.location.href = newUrl;
  });
});
